<template>
  <div>
    <div class="sg-resource-title">
      <div>{{ $t("RAM.TENCENT.SG.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:tencent:securityGroupResource:update'
          ]"
          :loading="updateLoading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:tencent:securityGroupResource:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <sg-resource-search ref="child"></sg-resource-search>
    <table-sg-resource></table-sg-resource>
  </div>
</template>

<script>
import SgResourceSearch from "./SgResourceSearch.vue";
import TableSgResource from "./TableSgResource.vue";
let tableSgResource = TableSgResource;

export default {
  name: "SgResource",
  components: {
    SgResourceSearch,
    TableSgResource
  },
  data() {
    return {
      updateLoading: false,
      modal_loading: false
    };
  },
  methods: {
    update() {
      this.updateLoading = true;
      this.$api.resourceManagement
        .updateTencentResource({
          companyId: this.$refs.child.companyId,
          accountIdList: this.$refs.child.accountSearchKey,
          resourceManagement: 610,
          accountType: 6
        })
        .then(res => {
          this.updateLoading = false;
          this.$Message.success(this.$t("common.updateSuccess"));
          setTimeout(() => {
            tableSgResource.methods.showAll();
          }, 1000);
        })
        .catch(() => {
          this.updateLoading = false;
          this.$Message.error(this.$t("common.updateFail"));
        });
    },
    exportList() {
      let exportDTO = {
        companyId: this.$refs.child.companyId,
        accountIds: this.$refs.child.accountSearchKey,
        accountName: this.$refs.child.accountName
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t("common.exporting")
      });
      this.$api.resourceManagement.exportTencentSg(exportDTO).then(res => {
        let fileName = this.$t("RAM.export.tencentSg");
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success(this.$t("common.exportSuccess"));
      }).catch(() => {
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.error(this.$t("common.exportFail"));
      });
    }
  }
};
</script>

<style scoped>
.sg-resource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.sg-resource-title > div:nth-child(1) {
  float: left;
}
.sg-resource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/tencent/sg/SgResource.vue